import React, { useState, useEffect } from 'react'
import SearchPanel from '../../components/SearchPanel'
import GridPanel from '../../components/GridPanel'
import PropTypes from "prop-types";
import _ from 'lodash'
import { isMobileOnly } from 'mobile-device-detect';

const GridSearchTemplate = ({ options, onGridUpdate, onSearchComplete, onSearchChange, data, onSelected }) => {
  const [_data, setData] = useState([])
   // Data passed from parent component overrides internal data
  useEffect(() => {
    setData(data);
  }, [data])

  const searchComplete = (data, state) => {
    if (onSearchComplete) {
      var result = onSearchComplete(data, state)
      if (result instanceof Promise){
        result.then(retval=>{
          if (retval) {
            setData(data)
          }
        });
      } else if (result) {
        setData(data)
      }
    } else {
      setData(data)
    }
  }

  const onUpdate = (added, changed, deleted) => {
    let updated = _data?[..._data]:[]
    if (added){
        updated = [...updated, ...added]
    }
    if (changed) {
        _.forEach(changed, (value, key) => {
            updated[key] = {...updated[key], ...value}
        })
        
    }

    let beforeDelete;
    if (deleted) {
        beforeDelete = updated;
        updated = updated.filter((x, i)=>!deleted.includes(i))
    }
    
    setData(updated)

    if (onGridUpdate) {
      onGridUpdate(added, changed, deleted, updated, beforeDelete)
    }
  }

  return (
    <div className={"GridSearchTemplate "+ (isMobileOnly ? "MobileSearchTemplate":"")} style={{ flexDirection: "column", flex: 1, display: "flex", width: "100%", overflow: isMobileOnly ? "auto": "hidden" }}>
      <div className="SearchGrid">
        <SearchPanel options={options.search} onSetState={onSearchChange} onSearchComplete={searchComplete}/>
      </div>
      <div style={{ flex: 1, display: "flex", 'overflowX': options.grid.scrollbarX ? isMobileOnly ? 'visble' : 'auto' : 'hidden' }}>
        <GridPanel options={{ ...options.grid, title: options.search.title }} data={_data} onUpdate={onUpdate} onSelected={onSelected} />
      </div>
    </div>
  )
}

GridSearchTemplate.propTypes = {
  options: PropTypes.object,
  onGridUpdate: PropTypes.func,
  onSearchComplete: PropTypes.func,
  data: PropTypes.any,
  onSelected: PropTypes.func,
  onSearchChange: PropTypes.func,
  selectionIndexes: PropTypes.array
}
export default GridSearchTemplate